import { ADMIN, ifyouApi } from './config';

export const adminUserApi = {
  login: (profileObj) =>
    ifyouApi
      .post(`${ADMIN}/login`, {
        googleId: profileObj.googleId,
        name: profileObj.name,
        email: profileObj.email,
      })
      .then((res) => res.data)
      .catch((error) => error),
  join: (googleId, adminData) =>
    ifyouApi
      .post(`${ADMIN}/join`, {
        googleId: googleId,
        name: adminData.name,
        email: adminData.email,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          console.log(
            `status: ${error.response.status} / data: ${JSON.stringify(
              error.response.data,
            )}`,
          );
          alert(
            `유저 등록 실패! \n **error message: ${error.response.data.koMessage}`,
          );
          return false;
        }
      }),
  updateInfo: (googleId, adminData) =>
    ifyouApi
      .post(`${ADMIN}/detail-update`, {
        googleId: googleId,
        name: adminData.name,
        organization: adminData.organization,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          console.log(
            `status: ${error.response.status} / data: ${JSON.stringify(
              error.response.data,
            )}`,
          );
          alert(
            `유저 등록 실패! \n **error message: ${error.response.data.koMessage}`,
          );
          return false;
        }
      }),
};
